<p-accordion-panel [value]="index()">
  <p-accordion-header>
    <div class="me-4 flex flex-1 items-center justify-between gap-4">
      <div class="flex items-center gap-2 text-sm text-gray-400">
        <span>{{ panelCount() }}</span>
        <span>{{ currentName$ | async | noData }}</span>
      </div>

      <div>
        @if (shouldRemove()) {
          <p-button
            (onClick)="handlePriceRemoveClick()"
            severity="danger"
            label="Usuń"
            appPrimengButton />
        }
      </div>
    </div>
  </p-accordion-header>

  <p-accordion-content>
    <div class="grid grid-cols-2 gap-4">
      <app-form-control label="Kraj">
        <p-select
          (onFilter)="handleSelectFilterChange($event)"
          [filter]="true"
          [formControl]="priceFormGroup().controls.countryId"
          [options]="valueOrDefault(countrySelectItems$ | async, [])"
          appPrimengSelect
          [fluid]="true"
          placeholder="Wybierz kraj" />
      </app-form-control>

      <app-form-control label="Kwota">
        <input
          [formControl]="priceFormGroup().controls.price"
          pInputText
          placeholder="Wprowadź kwotę"
          type="number" />
      </app-form-control>

      <div class="col-span-2">
        <app-form-control label="Metody płatności">
          <p-multi-select
            [fluid]="true"
            [formControl]="priceFormGroup().controls.paymentMethodIds"
            [options]="valueOrDefault(paymentMethodSelectItems$ | async, [])"
            appPrimengMultiselect />
        </app-form-control>
      </div>
    </div>
  </p-accordion-content>
</p-accordion-panel>
